'use es6';

import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const List = styled.div.withConfig({
  displayName: "SnowflakeFilterList__List",
  componentId: "zare3b-0"
})(({
  theme: _theme
}) => {
  return {
    '& > *:first-child': {
      marginTop: _theme.space['0']
    }
  };
});
const SnowflakeFilterList = ({
  children,
  ['data-test-id']: dataTestId
}) => /*#__PURE__*/_jsx(List, {
  "data-test-id": dataTestId,
  children: children
});
export default SnowflakeFilterList;